<script setup lang="ts">
  import { useField } from 'vee-validate';
  import { watch } from 'vue';
  import type { SelectProps } from '~/models/form-field';

  const { name, rules, attributes, items, selectedItem } = defineProps<SelectProps>();

  const { value, meta, errorMessage } = useField(name, rules, { type: 'default' });

  watch(
    () => selectedItem,
    (newValue) => {
      if (newValue) {
        value.value = newValue;
      }
    }
  );

  const selectOption = (optionValue: string) => {
    value.value = optionValue;
  };
</script>

<template>
  <div
    :class="[
      'form-select',
      {
        'form-select--error': !!errorMessage,
        'form-select--success': meta.valid
      }
    ]">
    <div class="form-select__wrapper">
      <input
        :id="name"
        v-model="value"
        readonly
        v-bind="attributes"
        class="form-select__select"
        :name="name" />
      <label
        :for="name"
        class="hidden" />
    </div>
    <div class="form-select__dropdown">
      <ul>
        <li
          v-for="(item, index) in items"
          :key="index"
          :value="item.value"
          class="form-select__option"
          @click="selectOption(item.value)">
          {{ item.label }}
        </li>
      </ul>
    </div>
    <div
      v-if="errorMessage"
      class="form-select__error">
      <span />
      <span>{{ errorMessage }}</span>
    </div>
  </div>
</template>
